import ArrowIcon from 'icons/arrow.svg';
import { SiteContext } from 'libs/contexts';
import { useContext, useState } from 'react';
import { cls } from 'reactutils';

type HeaderDropdownProps = {
  className?: string;
  title: string;
  children: React.ReactNode;
  showTipTitle?: boolean;
  showArrow?: boolean;
  showBorder?: boolean;
  arrowType?: 'border' | 'svg';
  as?: string;
  href?: string;
};

export default function HeaderDropdown({
  className,
  title,
  children,
  showTipTitle = true,
  showArrow = false,
  arrowType = 'border',
  as,
  href,
}: HeaderDropdownProps) {
  const [show, setShow] = useState(false);
  const Tag = as === 'a' ? 'a' : 'span';
  const site = useContext(SiteContext);

  return (
    <div
      className={cls('dropdown', show && 'on', className)}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <Tag className="title" title={showTipTitle ? title : ''} href={as === 'a' ? href : undefined}>
        {title}
      </Tag>

      {showArrow && arrowType === 'border' && <span className="icon" />}
      {showArrow && arrowType === 'svg' && (
        <i className="svg-icon">
          <ArrowIcon />
        </i>
      )}
      <div className="content">{children}</div>
      <style jsx>{`
        .dropdown {
          width: auto;
          height: 20px;
          position: relative;
        }
        .show-border {
          border-right: 1px solid red;
        }

        .border-bar {
          position: absolute;
          top: 50%;
          height: 10px;
          right: -12px;
          transform: translate(-50%, -50%);
          width: 1px;
          background: red;
        }

        .dropdown.on .icon {
          transform: rotate(-180deg);
        }
        .dropdown.on .content {
          display: block;
        }
        .title {
          display: inline-block;
          vertical-align: top;
          line-height: 20px;
          font-size: 16px;
          color: #000;
          cursor: pointer;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon {
          display: inline-block;
          vertical-align: top;
          margin-top: 9px;
          margin-left: 3px;

          border-top: 4px solid ${site?.global?.platformMainColor};
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          transition: transform 0.3s;
        }
        .content {
          display: none;
          position: absolute;
          width: auto;
          height: auto;
          top: 20px;
          right: 0;
          z-index: 1009;
        }

        .svg-icon {
          margin-left: 5px;
        }

        .svg-icon :global(svg) {
          width: 8px;
          height: auto;
          transform: rotate(90deg);
          transition: all 0.3s;
        }
        .svg-icon :global(path) {
          fill: #ddd;
        }

        .dropdown.on .svg-icon :global(svg) {
          transform: rotate(270deg);
        }
      `}</style>
    </div>
  );
}
